export default "__VITE_ASSET__C5Q8_0Ow__"